import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ObservatoryHomeComponent } from './pages/home/home.component';

export const routes: Routes = [
  {
    path: 'documentation',
    loadChildren: () => import('./pages/documentation/documentation.module').then((m) => m.DocumentationModule),
  },

  {
    path: 'input',
    loadChildren: () => import('./pages/input/input.module').then((m) => m.InputModule),
  },

  {
    path: 'page',
    loadChildren: () => import('./pages/page/page.module').then((m) => m.PageModule),
  },

  {
    path: 'experimental',
    loadChildren: () => import('./pages/experimental/experimental.module').then((m) => m.ExperimentalModule),
  },

  {
    path: 'shared-styles',
    loadChildren: () => import('./pages/shared-styles/shared-styles.module').then((m) => m.SharedStylesModule),
  },

  {
    path: 'design-tokens',
    loadChildren: () => import('./pages/design-tokens/design-tokens.module').then((m) => m.DesignTokensModule),
  },

  {
    path: 'i18n',
    loadChildren: () => import('./pages/i18n/i18n.module').then((m) => m.I18nModule),
  },

  {
    path: 'drag-and-drop',
    loadComponent: () => import('./pages/drag-and-drop/drag-and-drop.component').then((c) => c.DragAndDropComponent),
  },

  {
    path: 'alert',
    loadChildren: () => import('./pages/alert/alert.module').then((m) => m.AlertModule),
  },

  {
    path: 'badge',
    loadChildren: () => import('./pages/badge/badge.module').then((m) => m.BadgeModule),
  },

  {
    path: 'number-with-change',
    loadChildren: () =>
      import('./pages/number-with-change/number-with-change.module').then((m) => m.NumberWithChangeModule),
  },

  {
    path: 'date-pipe',
    loadChildren: () => import('./pages/date-pipe/date-pipe.module').then((m) => m.DatePipeModule),
  },

  {
    path: 'escape-html-pipe',
    loadChildren: () => import('./pages/escape-html-pipe/escape-html-pipe.module').then((m) => m.EscapeHtmlPipeModule),
  },

  {
    path: 'phone-number-pipe',
    loadComponent: () =>
      import('./pages/phone-number-pipe/phone-number-pipe.component').then((c) => c.PhoneNumberPipeComponent),
  },

  {
    path: 'button',
    loadChildren: () => import('./pages/button/button.module').then((m) => m.ButtonModule),
  },

  {
    path: 'button-group',
    loadChildren: () => import('./pages/button-group/button-group.module').then((m) => m.ButtonGroupModule),
  },

  {
    path: 'button-toggle-group',
    loadChildren: () =>
      import('./pages/button-toggle-group/button-toggle-group.module').then((m) => m.ButtonToggleGroupModule),
  },

  {
    path: 'button-loading-indicator',
    loadComponent: () =>
      import('./pages/button-loading-indicator/button-loading-indicator.component').then(
        (m) => m.ButtonLoadingIndicatorComponent,
      ),
  },

  {
    path: 'contact-info-card',
    loadChildren: () =>
      import('./pages/contact-info-card/contact-info-card.module').then((m) => m.ContactInfoCardModule),
  },

  {
    path: 'empty-state',
    loadChildren: () => import('./pages/empty-state/empty-state.module').then((m) => m.EmptyStateModule),
  },

  {
    path: 'popover',
    loadChildren: () => import('./pages/popover/popover.module').then((m) => m.PopoverModule),
  },

  {
    path: 'progress-bar',
    loadChildren: () => import('./pages/progress-bar/progress-bar.module').then((m) => m.ProgressBarModule),
  },

  {
    path: 'snackbar',
    loadChildren: () => import('./pages/snackbar/snackbar.module').then((m) => m.SnackbarModule),
  },

  {
    path: 'date-range-presets',
    loadChildren: () =>
      import('./pages/date-range-presets/date-range-presets.module').then((m) => m.DateRangePresetsModule),
  },

  {
    path: 'uploader',
    loadChildren: () => import('./pages/uploader/uploader.module').then((m) => m.UploaderModule),
  },
  {
    path: 'tooltip',
    loadChildren: () => import('./pages/tooltip/tooltip.module').then((m) => m.TooltipModule),
  },
  {
    path: 'transcript',
    loadChildren: () => import('./pages/transcript/transcript.module').then((m) => m.TranscriptModule),
  },
  {
    path: 'currency-pipe',
    loadChildren: () => import('./pages/currency-pipe/currency-pipe.module').then((m) => m.CurrencyPipeModule),
  },

  {
    path: 'nav',
    loadChildren: () => import('./pages/nav/nav.module').then((m) => m.NavModule),
  },

  {
    path: 'page-nav',
    loadChildren: () => import('./pages/page-nav/page-nav.module').then((m) => m.PageNavModule),
  },

  {
    path: 'nav-layout',
    loadChildren: () => import('./pages/nav-layout/nav-layout.module').then((m) => m.NavLayoutModule),
  },

  {
    path: 'form-field',
    loadChildren: () => import('./pages/form-field/form-field.module').then((m) => m.FormFieldModule),
  },

  {
    path: 'timezone-selector',
    loadChildren: () =>
      import('./pages/timezone-selector/timezone-selector.module').then((m) => m.TimezoneSelectorModule),
  },

  {
    path: 'frequency',
    loadChildren: () => import('./pages/frequency/frequency.module').then((m) => m.FrequencyModule),
  },

  {
    path: 'table',
    loadChildren: () => import('./pages/table/table.module').then((m) => m.TableModule),
  },

  {
    path: 'card',
    loadChildren: () => import('./pages/card/card.module').then((m) => m.CardModule),
  },

  {
    path: 'expansion-panel',
    loadChildren: () => import('./pages/expansion-panel/expansion-panel.module').then((m) => m.ExpansionPanelModule),
  },

  {
    path: 'modal',
    loadChildren: () => import('./pages/modal/modal.module').then((m) => m.ModalModule),
  },

  {
    path: 'address-pipe',
    loadChildren: () => import('./pages/address-pipe/address-pipe.module').then((m) => m.AddressPipeModule),
  },

  {
    path: 'chip',
    loadChildren: () => import('./pages/chip/chip.module').then((m) => m.ChipModule),
  },

  {
    path: 'menu',
    loadChildren: () => import('./pages/menu/menu.module').then((m) => m.MenuModule),
  },

  {
    path: 'slide-toggle',
    loadChildren: () => import('./pages/slide-toggle/slide-toggle.module').then((m) => m.SlideToggleModule),
  },

  {
    path: 'tabs',
    loadChildren: () => import('./pages/tabs/tabs.module').then((m) => m.TabsModule),
  },

  {
    path: 'email-viewer',
    loadChildren: () => import('./pages/email-viewer/email-viewer.module').then((m) => m.EmailViewerModule),
  },

  {
    path: 'comment',
    loadChildren: () => import('./pages/comment/comment.module').then((m) => m.CommentModule),
  },

  {
    path: 'experimental/infinite-scroll-trigger',
    loadChildren: () =>
      import('./pages/experimental/infinite-scroll-trigger/infinite-scroll-trigger.module').then(
        (m) => m.InfiniteScrollTriggerModule,
      ),
  },

  {
    path: 'chat',
    loadChildren: () => import('./pages/chat/chat.module').then((m) => m.ChatModule),
  },

  {
    path: 'chat-composer',
    loadChildren: () => import('./pages/chat-composer/chat-composer.module').then((m) => m.ChatComposerModule),
  },

  {
    path: 'avatar',
    loadChildren: () => import('./pages/avatar/avatar.module').then((m) => m.AvatarModule),
  },

  {
    path: 'i-trust-this-html-pipe',
    loadChildren: () =>
      import('./pages/i-trust-this-html-pipe/i-trust-this-html-pipe.module').then((m) => m.ITrustThisHtmlPipeModule),
  },
  {
    // `safe-html-pipe` was renamed to `i-trust-this-html-pipe` so we redirect to the new page
    path: 'safe-html-pipe',
    redirectTo: '/i-trust-this-html-pipe',
    pathMatch: 'full',
  },

  {
    path: 'ordinal-pipe',
    loadChildren: () => import('./pages/ordinal-pipe/ordinal-pipe.module').then((m) => m.OrdinalPipeModule),
  },

  {
    path: 'statistic',
    loadChildren: () => import('./pages/statistic/statistic.module').then((m) => m.StatisticModule),
  },

  {
    path: 'async-status-pipe',
    loadChildren: () =>
      import('./pages/async-status-pipe/async-status-pipe.module').then((m) => m.AsyncStatusPipeModule),
  },

  {
    path: 'truncate-url-pipe',
    loadChildren: () =>
      import('./pages/truncate-url-pipe/truncate-url-pipe.module').then((m) => m.TruncateUrlPipeModule),
  },

  {
    path: 'markdown-pipe',
    loadChildren: () => import('./pages/markdown-pipe/markdown-pipe.module').then((m) => m.MarkdownPipeModule),
  },

  {
    path: 'loading-spinner',
    loadChildren: () => import('./pages/loading-spinner/loading-spinner.module').then((m) => m.LoadingSpinnerModule),
  },

  {
    path: 'rich-text-editor',
    loadChildren: () => import('./pages/rich-text-editor/rich-text-editor.module').then((m) => m.RichTextEditorModule),
  },

  {
    path: 'side-panel',
    loadChildren: () => import('./pages/side-panel/side-panel.module').then((m) => m.SidePanelModule),
  },

  {
    path: 'icon',
    loadChildren: () => import('./pages/icon/icon.module').then((m) => m.IconModule),
  },

  {
    path: 'ai-icon',
    loadChildren: () => import('./pages/ai-icon/ai-icon.module').then((m) => m.AiIconModule),
  },

  {
    path: 'tags',
    loadChildren: () => import('./pages/tags/tags.module').then((m) => m.TagsModule),
  },

  {
    path: 'stepper',
    loadChildren: () => import('./pages/stepper/stepper.module').then((m) => m.StepperModule),
  },

  {
    path: 'ai-text-button',
    loadChildren: () => import('./pages/ai-text-button/ai-text-button.module').then((m) => m.AiTextButtonModule),
  },

  {
    path: 'confirmation-modal',
    loadChildren: () =>
      import('./pages/confirmation-modal/confirmation-modal.module').then((m) => m.ConfirmationModalModule),
  },

  {
    path: 'sticky-footer',
    loadChildren: () => import('./pages/sticky-footer/sticky-footer.module').then((m) => m.StickyFooterModule),
  },

  {
    path: 'page-not-found-404',
    loadChildren: () =>
      import('./pages/page-not-found-404/page-not-found-404.module').then((m) => m.PageNotFound404Module),
  },
  {
    path: 'three-panel',
    loadChildren: () =>
      import('./pages/galaxy-three-panel/galaxy-three-panel.module').then((m) => m.GalaxyThreePanelModule),
  },
  {
    path: 'filter',
    loadChildren: () => import('./pages/filter/filter.module').then((m) => m.FilterModule),
  },
  {
    path: 'page-no-access-unauthorized',
    loadChildren: () =>
      import('./pages/page-no-access-unauthorized/page-no-access-unauthorized.module').then(
        (m) => m.PageNoAccessUnauthorizedModule,
      ),
  },
  {
    path: 'code-sample',
    loadChildren: () => import('./pages/code-sample/code-sample.module').then((m) => m.CodeSampleModule),
  },

  {
    path: 'segmented-control',
    loadComponent: () =>
      import('./pages/segmented-control/segmented-control.component').then((c) => c.SegmentedControlComponent),
  },

  {
    path: 'docs/text',
    loadComponent: () => import('./pages/docs-text/docs-text.component').then((c) => c.DocsTextComponent),
  },

  //////////////////////////////////////////////////////////////////
  // leave the `Home Page` and 'PageNotFoundComponent` routes last
  //////////////////////////////////////////////////////////////////
  {
    path: '',
    pathMatch: 'full',
    component: ObservatoryHomeComponent,
  },
  {
    path: '**',
    loadComponent: () => import('@vendasta/galaxy/page-not-found-404').then((c) => c.PageNotFound404Component),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'disabled',
      anchorScrolling: 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
